module.exports = __webpack_public_path__ + "media/assets/images/flags/ru-0b2b092d76f5eb0aca1c84206ceb656a.svg";